import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import Colors from '../common/NekoTheme';
import { Icon, InlineIcon, IconifyIcon } from '@iconify/react';
import folderIcon from '@iconify/icons-mdi/folder';
import folderOpen from '@iconify/icons-mdi/folder-open';
import imageMultipleOutline from '@iconify/icons-mdi/image-multiple-outline';
import chevronRight from '@iconify/icons-mdi/chevron-right';
import chevronDown from '@iconify/icons-mdi/chevron-down';

const StyledNekoFinder = props => {

  const { chevron = true } = props;

  const children = React.Children.map(props.children, child => {
    return React.cloneElement(child, {
      chevron
    });
  });

  return (
    children
  );
};

const FinderTitle = Styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 8px;

  &.can-expand {
    cursor: pointer;
  }

  p {
    margin: 0 0 0 8px;
  }
`;

const ChevronSpace = Styled.div`
  height: 24px;
  width: 24px;
`;

const ItemContainer = Styled.div`
  border-left: 1px solid ${Colors.finderBorder};
  margin-left: 12px;
  padding-left: 6px;

  &.no-line {
    border-left: 0;
    padding-left: 12px;
  }

  &.no-chevron {
    border-left: 0;
    margin-left: 0;
    padding-left: 0;
  }
`;

const StyledNekoFinderItem = props => {

  const defaultIcons = {
    gallery: imageMultipleOutline
  }

  const { title, chevron } = props;
  const isFolder = !!!props.icon;
  const isCustomizedIcon = !!props.icon;
  const hasChild = !!props.children;
  const [ expanded, setExpanded ] = React.useState(false);
  const [ icon, setIcon ] = React.useState(() => {
    if (typeof props.icon === 'string' && Object.keys(defaultIcons).includes(props.icon)) {
      return defaultIcons[props.icon];
    } else if (props.icon) {
      return props.icon;
    }
    return folderIcon
  });

  const onClick = () => {
    if (!isFolder && !hasChild) return;
    if (!isCustomizedIcon) {
      setIcon(expanded ? folderIcon : folderOpen);
    }
    setExpanded(!expanded);
  }

  const children = React.Children.map(props.children, child => {
    return React.cloneElement(child, {
      chevron
    });
  });

  return (
    <div>
      <FinderTitle onClick={onClick} className={`${isFolder || children ? 'can-expand' : ''}`}>
        {chevron
          ? isFolder || children
            ? <Icon icon={expanded ? chevronDown : chevronRight} width="1.5rem" height="1.5rem" />
            : <ChevronSpace></ChevronSpace>
          : null
        }
        <Icon icon={icon} color={Colors.blue} width="1.5rem" height="1.5rem" />
        <p>{ title }</p>
      </FinderTitle>
      {expanded && <ItemContainer className={`${isFolder ? '' : 'no-line'} ${chevron ? '' : 'no-chevron'}`}>{children}</ItemContainer>}
    </div>
  )
}

const NekoFinder = (props) => {
  return (<StyledNekoFinder {...props} />);
}

NekoFinder.propTypes = {
  chevron: PropTypes.bool
};

NekoFinder.defaultProps = {
  chevron: true
};

const NekoFinderItem = (props) => {
  return (<StyledNekoFinderItem {...props} />);
}

NekoFinderItem.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.instanceOf(IconifyIcon), PropTypes.oneOf(['gallery'])]),
  title: PropTypes.string
};

NekoFinderItem.defaultProps = {
  icon: folderIcon,
  title: undefined
};

export { NekoFinder, NekoFinderItem };
